import React, { useEffect, useState } from 'react'
import { StyledOptionsWrapper, StyledStyledTextField } from './styles'
import { Typography } from '@mui/material'
import { grey } from '../../../../../../colors'
import { NOT_APPLICABLE } from '../../CreateMultipleChoiceQuestionCard'

interface LinearScaleOptionProps {
  label: string
  optionIndex: number
  points?: number
  isNaFlipped?: boolean
  onLabelChange: (optionIndex: number, newLabel: string) => void
  onPointsChange: (optionIndex: number, newPoints: number) => void
}

const LinearScaleOption: React.FC<LinearScaleOptionProps> = ({ label, optionIndex, points, isNaFlipped, onLabelChange, onPointsChange }) => {
  const placeholders = ['e.g. Strongly disagree', 'e.g. Disagree', 'e.g. Neutral', 'e.g. Agree', 'e.g. Strongly agree']

  const handleLabelInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onLabelChange(optionIndex, e.target.value)
  }

  const handlePointsInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const newPoints = Number(e.target.value)
    if (!isNaN(newPoints)) {
      onPointsChange(optionIndex, newPoints)
    }
  }

  const placeholderText = isNaFlipped
    ? placeholders?.[optionIndex - 1] || 'Type Option'
    : placeholders?.[optionIndex] || 'Type Option'

  const isDisabled = label === NOT_APPLICABLE
  return (
    <StyledOptionsWrapper key={optionIndex} style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      {label !== NOT_APPLICABLE
        ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <Typography color={grey[150]} fontWeight={500} style={{ minWidth: 50 }}>Points:</Typography>
          <input
            type="number"
            min={0}
            value={points ?? optionIndex + 1}
            onChange={handlePointsInput}
            style={{ width: 60, padding: '4px 8px', borderRadius: 4, border: `1px solid ${grey[200]}`, fontSize: 14 }}
          />
        </div>
          )
        : (
        <Typography color={grey[150]} fontWeight={500} style={{ minWidth: 50 }}>(N/A)</Typography>
          )}
      <StyledStyledTextField
        placeholder={placeholderText}
        value={label}
        onChange={handleLabelInput}
        disabled={isDisabled}
        style={{ flex: 1 }}
      />
    </StyledOptionsWrapper>
  )
}

export default LinearScaleOption
